// ============================================================================
// Jeu d'icônes duotone (charte Hecto Forma).
//   Duotone = une forme de fond à faible opacité + un tracé d'accent plein, les
//   deux en `currentColor`. Elles se recolorent donc avec le texte parent et ne
//   demandent aucun asset.
//   Elles servent à casser les murs de texte : une icône par ligne de bloc,
//   jamais deux dans le même bloc.
// ============================================================================

const PATHS: Record<string, { bg: string; fg: string }> = {
  // Temps
  clock: {
    bg: "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Z",
    fg: "M12 6.5a1 1 0 0 1 1 1v4.1l2.6 1.5a1 1 0 1 1-1 1.74l-3.1-1.8a1 1 0 0 1-.5-.87V7.5a1 1 0 0 1 1-1Z",
  },
  // Effort — la simplicité, l'étincelle
  spark: {
    bg: "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Z",
    fg: "M12 6l1.4 3.3L16.8 10l-3.4 1.4L12 14.7l-1.4-3.3L7.2 10l3.4-.7L12 6Zm4.6 8l.7 1.6 1.7.4-1.7.7-.7 1.6-.7-1.6-1.7-.7 1.7-.4.7-1.6Z",
  },
  // Routine — le geste qui revient
  repeat: {
    bg: "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Z",
    fg: "M8.4 9.2A4 4 0 0 1 15.6 9h-1.9a.9.9 0 0 0 0 1.8h3.5c.5 0 .9-.4.9-.9V6.4a.9.9 0 0 0-1.8 0v.9A5.8 5.8 0 0 0 6.7 8.6a.9.9 0 1 0 1.7.6Zm7.2 5.6a4 4 0 0 1-7.2.2h1.9a.9.9 0 0 0 0-1.8H6.8c-.5 0-.9.4-.9.9v3.5a.9.9 0 0 0 1.8 0v-.9a5.8 5.8 0 0 0 9.6-1.3.9.9 0 1 0-1.7-.6Z",
  },
  // Argent — le prix ancré
  tag: {
    bg: "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Z",
    fg: "M12 5.6a.9.9 0 0 1 .9.9v.5c1.4.2 2.4 1.1 2.4 2.3a.9.9 0 1 1-1.8 0c0-.3-.5-.7-1.5-.7s-1.5.4-1.5.7.5.7 1.5.7c1.8 0 3.3.9 3.3 2.5 0 1.2-1 2.1-2.4 2.3v.5a.9.9 0 1 1-1.8 0v-.5c-1.4-.2-2.4-1.1-2.4-2.3a.9.9 0 1 1 1.8 0c0 .3.5.7 1.5.7s1.5-.4 1.5-.7-.5-.7-1.5-.7c-1.8 0-3.3-.9-3.3-2.5 0-1.2 1-2.1 2.4-2.3v-.5a.9.9 0 0 1 .9-.9Z",
  },
  // Statut — la progression visible
  rise: {
    bg: "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Z",
    fg: "M17 7.2h-3.4a.9.9 0 0 0 0 1.8h1.3l-3.2 3.2-1.9-1.9a.9.9 0 0 0-1.3 0l-2.6 2.6a.9.9 0 0 0 1.3 1.3l2-2 1.9 1.9a.9.9 0 0 0 1.3 0l3.8-3.8v1.3a.9.9 0 0 0 1.8 0V8.1a.9.9 0 0 0-.9-.9Z",
  },
  // Programme — mesurer
  gauge: {
    bg: "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Z",
    fg: "M12 6.4a6 6 0 0 0-5 9.3.9.9 0 0 0 .8.4h8.4a.9.9 0 0 0 .8-.4 6 6 0 0 0-5-9.3Zm2.6 3.1a.9.9 0 0 1 .1 1.3l-2 2.3a1.3 1.3 0 1 1-1.4-1.2l2-2.3a.9.9 0 0 1 1.3-.1Z",
  },
  // Programme — basculer
  switch: {
    bg: "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Z",
    fg: "M7.5 8.6h6.1v-1a.9.9 0 0 1 1.5-.6l2.2 1.9a.9.9 0 0 1 0 1.4l-2.2 1.9a.9.9 0 0 1-1.5-.7v-1H7.5a.9.9 0 0 1 0-1.9Zm9 5h-6.1v-1a.9.9 0 0 0-1.5-.7l-2.2 1.9a.9.9 0 0 0 0 1.4l2.2 1.9a.9.9 0 0 0 1.5-.7v-1h6.1a.9.9 0 0 0 0-1.8Z",
  },
  // Programme — construire
  build: {
    bg: "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Z",
    fg: "M14.6 6.4a3.9 3.9 0 0 0-3.5 5.3l-4 4a1.3 1.3 0 0 0 1.8 1.8l4-4a3.9 3.9 0 0 0 4.9-4.8l-1.9 1.9a1.3 1.3 0 0 1-1.9-1.8l1.9-1.9a3.9 3.9 0 0 0-1.3-.5Z",
  },
  // Programme — répondre
  chat: {
    bg: "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Z",
    fg: "M7.6 7.5h8.8c.6 0 1 .5 1 1v4.9c0 .5-.4 1-1 1h-4.2l-2.6 2.2a.6.6 0 0 1-1-.5v-1.7H7.6c-.6 0-1-.5-1-1V8.5c0-.5.4-1 1-1Z",
  },
};

export function Icon({
  name,
  className = "h-6 w-6",
}: {
  name: string;
  className?: string;
}) {
  const p = PATHS[name];
  if (!p) return null;
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden focusable="false">
      <path d={p.bg} fill="currentColor" opacity="0.16" />
      <path d={p.fg} fill="currentColor" />
    </svg>
  );
}
